import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem } from 'react-bootstrap'
import { capitalizeAll } from '../../../utils';

// innder imports
import { BAND, MUSICIAN } from '../../../consts';

// css imports
import './bandfindertypepicker.css';

const BandFinderTypePicker = ({ userShouldEnter, pickerType, selected, onSelect = () => {}, datatypes, isSwitched, isAll, isLabelFlat }) => {
    const typeStr = (band, musician) => {
        if (isLabelFlat) return '';
        if (isSwitched) {
            return pickerType === BAND ? musician  : band;
        }

        return pickerType === BAND ? band : musician
    };

    const constTypeStr = (band, musician) => {
        return pickerType === BAND ? band : musician

    };

    const titleStr = (band, musician) => {
        if (isSwitched) {
            return pickerType === BAND ? musician  : band;
        }

        return pickerType === BAND ? band : musician
    }

    const onOpen = e => {
        console.log('open event', e);
    };

    const renderMenuItems = () => {
        if (!datatypes) return;

        let optionList = pickerType === BAND ? datatypes.categories.band : datatypes.categories.musician;
        if (isSwitched) {
            optionList = pickerType === BAND ? datatypes.categories.musician : datatypes.categories.band;
        }

        return optionList.map((o, i) => {
            if (i === 0 && isAll) {
                return ([
                    <MenuItem key={i + o.name + 'first'} eventKey={{}} onSelect={(eventKey) => onSelect(eventKey)}>הכל</MenuItem>,
                    <MenuItem key={i + o.name} eventKey={o} onSelect={(eventKey) => onSelect(eventKey)}>{capitalizeAll(o.singular)}</MenuItem>
                ])
            }

            return (
                <MenuItem key={i + o.name} eventKey={o} onSelect={(eventKey) => onSelect(eventKey)}>{capitalizeAll(o.singular)}</MenuItem>
            )
        })
    };

    const renderTitle = () => {
        if (!datatypes) return;

        if (typeof selected === 'string') {
            const cat = datatypes.categories[pickerType].filter(c => c.name === selected)[0];
            return cat && capitalizeAll(cat.singular);
        }

        return (selected && selected.singular && capitalizeAll(selected.singular)) || 'בחירה';
    };

    return (
        <div className={`band-finder-type-wrapper`}>
            <div className={`band-finder-type-title ${typeStr(BAND, MUSICIAN)} ${(userShouldEnter && userShouldEnter.indexOf('iWeAre') > -1 ? 'required' : '')}`}>
                <p onClick={e => onOpen(e)}>{titleStr('אנחנו', 'אני')}</p>
                <div className={`selector-wrapper rtl ${constTypeStr(BAND, MUSICIAN)}`}>
                    <DropdownButton
                        title={renderTitle() || 'בחירה'}
                        id="dropdown"
                        noCaret={true}
                    >
                        {renderMenuItems()}
                    </DropdownButton>
                </div>
            </div>
        </div>
    )
};

BandFinderTypePicker.propTypes = {
    pickerType: PropTypes.string,
    onSelect: PropTypes.func,
    userShouldEnter: PropTypes.array,
    selected: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    selectOptions: PropTypes.array,
    datatypes: PropTypes.object,
    isSwitched: PropTypes.bool,
    isAll: PropTypes.bool,
    isLabelFlat: PropTypes.bool
};

export default BandFinderTypePicker;



// WEBPACK FOOTER //
// ./src/Components/Elements/Pickers/BandFinderTypePicker.js